import ShortCoupleOpeningScreen from "@dana/Components/FindShortCouple/ShortCoupleOpeningScreen";
import ShortCoupleResultScreen from "@dana/Components/FindShortCouple/ShortCoupleResultScreen";
import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";
import { useEffect, useState } from "react";


const enum fields {
    assemblyDiagramImage = "assemblyDiagramImage",
    assemblyDiagramImageAltText = "assemblyDiagramImageAltText",
}

interface OwnProps extends PageProps {
    fields: {
        // Opening Screen
        [fields.assemblyDiagramImage]: string;
        [fields.assemblyDiagramImageAltText]: string;
    };
}

export interface FindShortCoupleShaftPageStyles {
    page?: MobiusPageProps;
}

export const findShortCoupleShaftPageStyles: FindShortCoupleShaftPageStyles = {
    page: {
        background: themeBackgrounds.offWhite,
        fullWidth: [true, true, true, true, true],
    },
}

const FindShortCoupleShaftPage = ({ id, fields }: OwnProps) => {

    const styles = findShortCoupleShaftPageStyles;

    const [pageNo, setPageNo] = useState<string | null>("1");
    const [series, setSeries] = useState<string | null>(null);
    const [clData, setClData] = useState<string | null>(null);
    const [queryStringCollected, setQueryStringCollected] = useState(false);

    useEffect(() => {
        if (typeof window !== "undefined") {
            const queryParams = new URLSearchParams(window.location.search);
            setPageNo(queryParams.get("page_no") ?? "1");
            setSeries(queryParams.get("series"));
            const clDataParam = queryParams.get("cl_data");
            const isValidFloat = clDataParam !== null && /^\d+(\.\d+)?$/.test(clDataParam.trim());
            if (!isValidFloat) {
                setQueryStringCollected(true);
                return;
            }
            setClData(clDataParam);
            setQueryStringCollected(true);
        }
    }, []);

    return (
        <Page {...styles.page}>
            {queryStringCollected && (!series || !clData) && (
                <ShortCoupleOpeningScreen />
            )}

            {queryStringCollected && series && clData && (
                <ShortCoupleResultScreen
                    pageNo={pageNo ? Number(pageNo) : 1}
                    series={series ?? ""}
                    clData={clData ? parseFloat(clData) : 0}
                    imageUrl={fields.assemblyDiagramImage}
                    imageAltText={fields.assemblyDiagramImageAltText}
                />
            )}
        </Page>
    )
};

const pageModule: PageModule = {
    component: FindShortCoupleShaftPage,
    definition: {
        displayName: "Find Short Couple Shaft Page",
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
            {
                fieldType: "Translatable",
                name: fields.assemblyDiagramImage,
                editorTemplate: "ImagePickerField",
                displayName: "Assembly Diagram Image",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.assemblyDiagramImageAltText,
                editorTemplate: "TextField",
                displayName: "Assembly Diagram Image Alt Text",
                defaultValue: "",
            },
        ],
    },
};

export default pageModule;
